import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TheaterComponent } from './components/theater/theater.component';

const routes: Routes = [
  {
    path: ':id',
    component: TheaterComponent,
    data: {animation: 'TheaterPage'}
  },
  {
    path: '',
    component: TheaterComponent,
    data: {animation: 'TheaterPage'}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TheaterRoutingModule { }
